<template>
  <div class="w-full lg:w-1/2 mx-auto">
    <div class="text-2xl">
      Add a new client from Mercury
    </div>

    <div class="my-6">
      <div class="text-base leading-normal">
        Please type in first name,last name or email of any of the applicants below.
        {{ getAppName }} will search through existing opportunities in your Mercury account.
        Please ensure that your 
        <router-link :to="{ name : 'broker-account', params : { brokerId : $store.state[$store.state.view + 'Module'].broker.id } }" tag="a" class="text-blue-500">Mercury account login details</router-link> are correct.
      </div>

      <div class="mt-8 w-1/3">
        <input type="text" v-model="email" class="input-standard" placeholder="Applicant first name, last name or email address" />
      </div>

      <div class="mt-2">
        <SubmitButton label="Search opportunities" v-bind:onClick="submit" v-bind:loading="loading"></SubmitButton>
      </div>

      <template v-if="opportunities != null">
        <template v-if="opportunities.length > 0">
          <div class="mt-8 text-base">
            We have found {{ opportunities.length }} opportunities related to that email address.
          </div>

          <div class="">
            <template v-for="(opp, inidex) in opportunities">
              <div class="p-4 bg-gray-200 mt-4">
                <Opportunity v-bind:opportunity="opp" />
                <div class="mt-6">
                  <button
                    v-on:click="addClientViaOpportunity(opp.id)"
                    class="text-white py-3 text-sm bg-green-500 hover:bg-green-600" style="width:350px;">Create a new client from this opportunity</button>
                </div>
              </div>
            </template>
          </div>
        </template>

        <template v-else>
          <div class="mt-6 w-1/4">
            <div class="">
              <img src="https://cdn2.iconfinder.com/data/icons/thin-line-icons-for-seo-and-development-1/64/SEO_cloud-512.png" class="w-12" />
            </div>
            <div class="text-gray-700">No opportunities found with that email address</div>
          </div>
        </template>
      </template>
    </div>

    <!-- <div class="py-6 px-4">
      <Footer></Footer>
    </div> -->
  </div>
</template>

<script>
  import { EventBus }     from '@/shared/event-bus';
  import PageHeader       from '@/shared/components/headers/PageHeader'
  import SubmitButton     from '@/shared/components/form/SubmitButton'
  import Opportunity      from './Opportunity'
  // import Footer           from '@/shared/components/Footer'

  export default {

    components : {
      SubmitButton,
      PageHeader,
      Opportunity
      // Footer
    },

    data() {
      return {
        loading      : false,
        email        : null, //'jayellis@simpology.com.au',
        opportunities: null
      }
    },

    methods : {
      submit() {
        this.loading = true
        this.apiGet({
          email : this.email,
        }, 'mercury/opportunities', (opportunities) => {
          this.loading       = false
          this.opportunities = opportunities
        })
      },

      addClientViaOpportunity(opportunityId) {
        this.$router.push({
          name  : 'mercury-opportunity-import-confirm', 
          params: {
            opportunityId : opportunityId
          }
        })
      }
    }
  }
</script>